import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../../redux/authSlice";
import { authAxios } from "../../utils/axiosConfig";
import {
	BookUser,
	CircleUser,
	FolderHeart,
	LogOut,
	UserPlus,
} from "lucide-react";
import { ROUTES } from "../../router/appRoutes";

const SideBarSmall = () => {
	const { role } = useSelector((state) => state.auth);
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const handleLogout = async (e) => {
		e.preventDefault();
		const response = await authAxios.post("/auth/logout");
		// console.log(response);
		await dispatch(logout());
		navigate(ROUTES.LOGIN);
	};

	return (
		<>
			<Link to={ROUTES.DASHBOARD}>
				<CircleUser
					width={32}
					className="sidebar_menu_icon"
				/>
			</Link>
			<Link to={ROUTES.DASHBOARD_PROJECTS}>
				<FolderHeart
					width={32}
					className="sidebar_menu_icon"
				/>
			</Link>
			{role === "admin" && (
				<>
					<Link to={ROUTES.DASHBOARD_USERS}>
						<BookUser
							width={32}
							className="sidebar_menu_icon"
						/>
					</Link>
					<Link
						to={ROUTES.DASHBOARD_USERS_ADD}
						className="dashboard_logout_btn"
					>
						<UserPlus
							width={32}
							className="sidebar_menu_icon"
						/>
					</Link>
				</>
			)}

			<Link
				onClick={handleLogout}
				className="dashboard_logout_btn"
			>
				<LogOut
					width={32}
					className="sidebar_menu_icon"
				/>
			</Link>
		</>
	);
};

export default SideBarSmall;
